import { ChevronUp } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCheveronUp = mkIcon(ChevronUp);